<script setup lang="ts">
import { onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useEditorStore } from '../stores/editor'
import { VoxelRenderer } from '../lib/voxel-renderer'

const host = ref<HTMLElement>()
const editor = useEditorStore()
let renderer: VoxelRenderer | undefined

onMounted(() => {
  if (!host.value) return
  renderer = new VoxelRenderer(host.value)
  renderer.onPick = ({ x, y, z, key }) => {
    const current = editor.document.data[z][y][x]
    if (editor.tool === 'erase') editor.setVoxel(x, y, z, '.', 'Erased voxel')
    else if (editor.tool === 'select') editor.select(key, false)
    else if (editor.tool === 'eyedropper' && current !== '.') { editor.selectedSymbol = current; editor.status = `Sampled ${current}` }
    else if (editor.tool === 'paint') editor.setVoxel(x, y, z, editor.selectedSymbol, 'Painted voxel')
  }
  renderer.update(editor.document)
})
watch(() => editor.revision, () => renderer?.update(editor.document))
onBeforeUnmount(() => renderer?.dispose())
</script>

<template>
  <div ref="host" class="viewport" aria-label="3D voxel viewport" tabindex="0"></div>
</template>

